/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TooltipButton } from 'common/react/components/tooltip-button';

export const StatsTableHead = ({
    headerGroup,
    skipColumns,
    primaryTooltipComponent,
    secondaryTooltipComponent,
    doNotRenderTooltipForRows,
    customCells,
    isProspectModal,
    activeColumn
}) => {
    // @ts-ignore
    const { render } = PULSE.app.templating;
    const isTouchScreen = PULSE.app.common.deviceHelper.isTouchScreen();
    const headers = headerGroup.headers.filter((column) => {
        if (!skipColumns) {
            return true;
        }
        return !skipColumns.includes(column.id);
    });
    const isProspect = headerGroup.isTableProspect;

    return (
        <thead>
            <tr
                {...headerGroup.getHeaderGroupProps()}
                className="stats-table__header-row"
            >
                {headers.map((column, colIndex) => {
                    const cellContent = column.render('Header');
                    const cellLabel = column.label || cellContent;

                    const { onClick, ...headerProps } = column.getHeaderProps(
                        column.getSortByToggleProps()
                    );

                    if (customCells && customCells[column.id]) {
                        return customCells[column.id](column, colIndex);
                    }

                    if (isProspect) {
                        headerProps.style = {
                            cursor: 'unset'
                        };

                        headerProps.title = null;
                    }

                    const Content = () => (
                        <>
                            <span
                                className={classnames(
                                    'stats-table__header-cell--content',
                                    {
                                        'stats-table__header-cell--is-current':
                                            activeColumn === 0 &&
                                            cellContent === 'OR'
                                                ? true
                                                : cellContent === activeColumn
                                    }
                                )}
                            >
                                {cellContent}
                            </span>
                            {column.isSorted && (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: render(
                                            {
                                                cssClass: classnames(
                                                    'stats-table__sort-icon',
                                                    {
                                                        'stats-table__sort-icon--flipped':
                                                            !column.isSortedDesc
                                                    }
                                                ),
                                                name: 'dropdown'
                                            },
                                            'common.svg-icon'
                                        )
                                    }}
                                ></span>
                            )}
                        </>
                    );

                    if (
                        !primaryTooltipComponent ||
                        isTouchScreen ||
                        doNotRenderTooltipForRows?.includes(column.id)
                    ) {
                        return (
                            <th
                                {...headerProps}
                                className={classnames(
                                    `stats-table__header-cell stats-table__header-cell--${column.id}`,
                                    {
                                        'stats-table__header-cell--sorted':
                                            column.isSorted
                                    },
                                    {
                                        'stats-table__header-cell--is-current-cell':
                                            column.Header === activeColumn
                                    }
                                )}
                                scope="col"
                                key={colIndex}
                            >
                                <div className="stats-table__header-cell-button-wrapper">
                                    <button
                                        className="stats-table__header-cell-button"
                                        onClick={onClick}
                                        disabled={isProspect || !column.canSort}
                                    >
                                        <Content />
                                    </button>
                                </div>
                            </th>
                        );
                    }

                    return (
                        <th
                            {...headerProps}
                            className={classnames(
                                `stats-table__header-cell stats-table__header-cell--${column.id}`,
                                {
                                    'stats-table__header-cell--sorted':
                                        column.isSorted
                                },
                                {
                                    'stats-table__header-cell--is-current-cell':
                                        column.Header === activeColumn
                                }
                            )}
                            scope="col"
                            key={colIndex}
                        >
                            <TooltipButton
                                id={`stats-leaders-sort-${column.id}`}
                                isProspectModal={isProspectModal}
                                externalTooltip
                                suppressFocusStyles
                                primaryTooltipContent={
                                    primaryTooltipComponent &&
                                    primaryTooltipComponent(column)
                                }
                                secondaryTooltipContent={
                                    secondaryTooltipComponent &&
                                    secondaryTooltipComponent(column)
                                }
                                classNames={{
                                    component:
                                        'stats-table__header-cell-button-wrapper',
                                    button: 'stats-table__header-cell-button'
                                }}
                                onClick={onClick}
                                disabled={isProspect || !column.canSort}
                                title={
                                    column.canSort
                                        ? `Sort by ${cellLabel}, ${getNextSortDirection(
                                              column
                                          )}`
                                        : null
                                }
                                description={
                                    secondaryTooltipComponent(column)?.props
                                        .content
                                        ? `${cellLabel}: ${
                                              secondaryTooltipComponent(column)
                                                  ?.props.content
                                          }`
                                        : ''
                                }
                                theme="dark"
                            >
                                <Content />
                            </TooltipButton>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};

StatsTableHead.propTypes = {
    headerGroup: PropTypes.object.isRequired,
    skipColumns: PropTypes.array,
    primaryTooltipComponent: PropTypes.any,
    secondaryTooltipComponent: PropTypes.any,
    doNotRenderTooltipForRows: PropTypes.arrayOf(PropTypes.string),
    customCells: PropTypes.object,
    isProspectModal: PropTypes.bool,
    activeColumn: PropTypes.number
};

const getNextSortDirection = (column) => {
    if (!column.isSorted) {
        return 'descending';
    }

    return column.isSortedDesc ? 'ascending' : 'descending';
};
